import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-reveal"
export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 0.1 },
    delay: { type: Number, default: 0 },
    animation: { type: String, default: "fade-up" }
  }

  connect() {
    this.element.classList.add('scroll-reveal')
    this.element.style.setProperty('--reveal-delay', `${this.delayValue}ms`)

    // Set initial state based on animation type
    this.setInitialState()

    // Wait for the browser to paint the hidden state before observing,
    // otherwise elements already in the viewport animate before opacity-0
    // is ever rendered, making the transition invisible.
    requestAnimationFrame(() => {
      this.observer = new IntersectionObserver(
        (entries) => this.handleIntersection(entries),
        {
          threshold: this.thresholdValue,
          rootMargin: '0px 0px -50px 0px'
        }
      )

      this.observer.observe(this.element)
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setInitialState() {
    const animations = {
      'fade-up': 'opacity-0 translate-y-8',
      'fade-down': 'opacity-0 -translate-y-8',
      'fade-left': 'opacity-0 translate-x-8',
      'fade-right': 'opacity-0 -translate-x-8',
      'fade': 'opacity-0',
      'scale': 'opacity-0 scale-95',
      'scale-up': 'opacity-0 scale-90'
    }

    const classes = animations[this.animationValue] || animations['fade-up']
    this.element.classList.add(...classes.split(' '))
    this.element.classList.add('transition-all', 'duration-700', 'ease-out')
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add a small delay before triggering animation
        setTimeout(() => {
          this.element.classList.remove(
            'opacity-0',
            'translate-y-8',
            '-translate-y-8',
            'translate-x-8',
            '-translate-x-8',
            'scale-95',
            'scale-90'
          )
          this.element.classList.add('opacity-100', 'translate-y-0', 'translate-x-0', 'scale-100')
        }, this.delayValue)

        // Unobserve after animating (one-time animation)
        this.observer.unobserve(this.element)
      }
    })
  }
}
